import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../store/ui-slice";
import AttendanceMain from "../../features/attendance/component/attendance-main";

const title = "Attendance";

const AttendancePage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <AttendanceMain />;
  // return "Attendance Page";
};

export default AttendancePage;
